<section>
  <h1>About</h1>
  <p>This is the about page.</p>
  <p><a href="https://github.com/kbarnes3/base-angular-app" target="_blank" rel="noopener noreferrer">Fork me on GitHub</a></p>
</section>
